module.exports = __webpack_public_path__ + "img/oxen.14da7763.svg";